Vue.asyncComponent('ak-wrapper', {
    data() {
        return {
            viewMode: null
        }
    },
    methods: {
        initViewMode() {
            // set the current viewMode
            this.viewMode = localStorage.getItem('ak-data-table-view-mode');
        },
        setViewMode(e) {
            console.log(e.detail.viewMode);
            this.viewMode = e.detail.viewMode;
            localStorage.setItem('ak-data-table-view-mode', e.detail.viewMode);
        },
        removeToast(toastId) {
            const index = this.$root.globalMessages.findIndex(message => message.id === toastId);
            this.$root.globalMessages.splice(index, 1);
        }
    },
    mounted() {
        this.initViewMode();
        this.$root.$el.addEventListener('view-mode-changed', this.setViewMode);
    },
    beforeDestroy() {
        this.$root.$el.removeEventListener('view-mode-changed',this.setViewMode)
    }
}, 'wrappers/ak-wrapper.html');
